import axios from 'axios';
import Swal from 'sweetalert2';

const genesData = require('./genes.json');
const proteinsData = require('./proteins.json');

function isValidUniProtAccession(input) {
  const found = proteinsData.some(protein => protein.PROTEIN_AN === input.trim());
  return found;
}

function isValidResidue(input) {
    const regex = /^[A-Z0-9]{6,10}(_[0-9]+)$/;
    const found = proteinsData.some(protein => protein.PROTEIN_AN === input.split("_")[0].trim());
    const test = regex.test(input.trim());
    let valid = false;

    if (test && found){
         valid = true;
    }
    return valid;
}

function isValidGeneSymbol(input) {
  const found = genesData.some(gene => gene.GENE_SYMBOL === input.trim());
  return found;
}

function isValidGeneResidue(input) {
    const regex = /^[A-Z0-9]{2,10}(_[0-9]+)$/;
    const found = genesData.some(gene => gene.GENE_SYMBOL === input.split("_")[0].trim());
    const test = regex.test(input.trim());
    let valid = false;

    if (test && found){
         valid = true;
    }
    return valid;
}

// Helper function to merge two lists of residues and remove duplicates
const mergeAndDeduplicate = (listA, listB) => {
  // Use a Map to store unique residues by their 'anPosition'
  const map = new Map();

  // Add all items from the first list
  for (const item of listA) {
    map.set(item.anPosition, item);
  }

  // Add all items from the second list (this will overwrite duplicates)
  for (const item of listB) {
    map.set(item.anPosition, item);
  }

  // Return an array of the unique, merged items
  return Array.from(map.values());
};


// Function to get inter-protein contact from API
// All INTER contacts of one structure (table + plots + Molstar).
export async function getInterContactsByStructure(target, identifier) {
  try {
    const query = {
      query: `query {
        contactsByStructure(target: "${target.toUpperCase()}", identifier: "${identifier}", inter: true) {
          total
          items { anPosition summary proteinUid identifier contactPosition distance details }
        }
      }`,
    };
    const resp = await axios.post(ATLANTIS_API, query);
    if (resp.data.errors || !resp.data.data) return { contacts: [], tooMany: false, total: 0 };
    const data = resp.data.data.contactsByStructure || { total: 0, items: [] };
    const total = data.total || 0;
    if (total > CONTACT_DISPLAY_LIMIT) return { contacts: [], tooMany: true, total };
    return { contacts: data.items || [], tooMany: false, total };
  } catch (error) {
    console.error(error);
    return { contacts: [], tooMany: false, total: 0 };
  }
}

// Search by residue: all INTER contacts of one an_position across every structure.
export async function getInterContactsByResidue(anPosition) {
  try {
    const query = {
      query: `query {
        contactsByTarget(target: "", anPosition: "${anPosition.toUpperCase()}", inter: true, pagination: {offset: 0, limit: ${CONTACT_DISPLAY_LIMIT}}) {
          total
          items { anPosition summary proteinUid identifier contactPosition distance details }
        }
      }`,
    };
    const resp = await axios.post(ATLANTIS_API, query);
    if (resp.data.errors || !resp.data.data) return { contacts: [], tooMany: false, total: 0 };
    const data = resp.data.data.contactsByTarget || { total: 0, items: [] };
    const total = data.total || 0;
    if (total > CONTACT_DISPLAY_LIMIT) return { contacts: [], tooMany: true, total };
    return { contacts: data.items || [], tooMany: false, total };
  } catch (error) {
    console.error(error);
    return { contacts: [], tooMany: false, total: 0 };
  }
}


// Function to get ligand from API
export async function getLigand(target) {

       try {

        const query = {
              query: `
                query getResiduesByGene {
                  residuesByGeneSymbol(geneSymbol: "${target.toUpperCase()}") {
                    anPosition
                    summary
                     ligands{
                        pdbId
                        ligand
                        inchikey
                        details
                        distance
                        annotation
                        ccd
                        url
                      }
                  }
                }
              `
            };

        const query_protein = {
              query: `
                query getResiduesByProtein {
                  residues(proteinAn: "${target.toUpperCase()}") {
                    anPosition
                    summary
                     ligands{
                        pdbId
                        ligand
                        inchikey
                        details
                        distance
                        annotation
                        ccd
                        url
                      }
                  }
                }
              `
            };

        const query_residue = {
              query: `
                query getResidueByPosition {
                  residue(anPosition: "${target.toUpperCase()}") {
                    anPosition
                    summary
                     ligands{
                        pdbId
                        ligand
                        inchikey
                        details
                        distance
                        annotation
                        ccd
                        url
                      }
                  }
                }
              `
            };

        const query_gene_residue = {
              query: `
                query getResidueByGeneAndPosition {
                  residueByGeneSymbolAndPosition(genePosition: "${target.toUpperCase()}") {
                    anPosition
                    summary
                    ligands{
                        pdbId
                        ligand
                        inchikey
                        details
                        distance
                        annotation
                        ccd
                        url
                      }
                  }
                }
              `
            };

        let contactData = null;
        let type = "";
        const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';

        if (isValidUniProtAccession(target) && !isValidResidue(target)){
           contactData = await axios.post(apiUrl, query_protein);
           type = "protein";
        } else if (isValidResidue(target)){
          contactData = await axios.post(apiUrl, query_residue);
          type = "residue";
        } else if (isValidGeneSymbol(target)) {
          contactData = await axios.post(apiUrl, query);
          type = "gene";
        }else if (isValidGeneResidue(target)) {
          contactData = await axios.post(apiUrl, query_gene_residue);
          type = "gene_residue";
        }

        const checkDataAndNavigate = () => {
          // Check for no errors and data is present
          if (!contactData.data.errors && contactData.data.data) {
            switch (type) {
              case "gene":
                 return contactData.data.data.residuesByGeneSymbol;
                break;
              case "residue":
                 return [contactData.data.data.residue];
                break;
              case "protein":
                 return contactData.data.data.residues;
                break;
              case "gene_residue":
                 return [contactData.data.data.residueByGeneSymbolAndPosition];
                break;
              default:
                return [];
            }
          }
        }

       return checkDataAndNavigate(); // Return the data retrieved

     } catch (error) {
          console.error(error);
       }
}

// Get PDB structure list from UniProt
export async function getPDBsFromUniprot(input) {
  const UNIPROT_URL = `https://rest.uniprot.org/uniprotkb/search?query=accession:${input.toUpperCase()}&fields=structure_3d&format=json`;

  try {
    const response = await fetch(UNIPROT_URL);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    const pdbIds = data.results?.flatMap(result =>
      result.uniProtKBCrossReferences
        ?.filter(ref => ref.database === "PDB")
        .map(ref => ref.id)
    ) || [];

    return pdbIds;
  } catch (error) {
    console.error('Failed to fetch PDBs from UniProt:', error);
    return [];
  }
}


const API_URL = 'https://api.atlantis.bioinfolab.sns.it/graphql';

export async function getPDB2Uniprot(pdb, uniac, uniprotPositions) {
    try {
        // Ensure uniprotPositions is always an array
        const positions = Array.isArray(uniprotPositions) ? uniprotPositions : [uniprotPositions];

        const query = {
            query: `
                query getPdbPosition($uniprotPositions: [Int!]!, $pdb: String!, $uniac: String!) {
                    getPdbPosition(uniprotPositions: $uniprotPositions, pdb: $pdb, uniac: $uniac) {
                        items {
                            pdbresPos
                        }
                    }
                }
            `,
            variables: { uniprotPositions: positions, pdb, uniac }
        };

        const { data } = await axios.post(API_URL, query, { headers: { 'Content-Type': 'application/json' } });

        // Extract items safely, defaulting to an empty array if undefined
        const items = data?.data?.getPdbPosition?.items ?? [];

        return items;
    } catch (error) {
        console.error(`Error fetching PDB to UniProt mapping: ${error.message}`, { pdb, uniac, uniprotPositions });
        return [];
    }
}


export async function getPDB2UniprotByChain(uniprotPositions, pdb, uniac, chain) {
    try {
        // Ensure uniprotPositions is always an array
        const positions = Array.isArray(uniprotPositions) ? uniprotPositions : [uniprotPositions];

        const query = {
            query: `
                query getPdbPositionByChain($uniprotPositions: [Int!]!, $pdb: String!, $uniac: String!, $chain: String!) {
                    getPdbPositionByChain(uniprotPositions: $uniprotPositions, pdb: $pdb, uniac: $uniac, chain: $chain) {
                        items {
                            pdbresPos
                        }
                    }
                }
            `,
            variables: { uniprotPositions: positions, pdb, uniac, chain }
        };

        const { data } = await axios.post(API_URL, query, { headers: { 'Content-Type': 'application/json' } });

        // Extract items safely, defaulting to an empty array if undefined
        const items = data?.data?.getPdbPositionByChain?.items ?? [];

       if (!items?.length) return; // Exit early if results are empty

        const mappedPositions = [];
        const chains = [];

        items.forEach(({ pdbresPos }) => {
          const chain = pdbresPos.split("|")[0];
          const position = parseInt(pdbresPos.match(/\d+/)?.[0]); // Fixed 'posStr' to 'pdbresPos'

          if (position && chain) {
            mappedPositions.push(position);
            chains.push(chain);
          }
        });
        return { mappedPositions, chains }; // Returning the mapped data

    } catch (error) {
        console.error(`Error fetching PDB to UniProt mapping: ${error.message}`, { pdb, uniac, uniprotPositions });
        return [];
    }
}


// Function to get ClinVar variants from API
export async function getVariants(target) {

       try {

        const query = {
              query: `
                query getResiduesByGene {
                  residuesByGeneSymbol(geneSymbol: "${target.toUpperCase()}", removeNoVariant: true) {
                    anPosition
                    unRefProtRe
                    afRes
                    unAnnNatVariants
                    unMoleculeProcessing
                    unLocation
                    unMotives
                    unDomains
                    pfamDomainPosHmm
                    unLigandsBindingSite
                    unAnnPropActiveSite
                    phosPtms
                    unGlycosylations
                    unLipidations
                    unModifiedRes
                    unDisulfideBongBridges
                    unSecondaryStructure
                    afPredictedSecondaryStructure
                    afConfidenceValue
                    unCrossLinks
                    inBindingRegion
                    summary
                    interproDomain
                    clinvarVariants {
                      locationG37
                      locationG38
                      ref
                      alt
                      variant
                      consequence
                      clinicalSignificance
                      disease
                      proteinPosition
                      aaChange
                      codon
                      alphamissenseScore
                      alphamissenseClass
                      url
                    }
                  }
                }
              `
            };

        const query_protein = {
              query: `
                query getResiduesByProtein {
                  residues(proteinAn: "${target.toUpperCase()}", removeNoVariant: true) {
                    anPosition
                      unRefProtRe
                    afRes
                    unAnnNatVariants
                    unMoleculeProcessing
                    unLocation
                    unMotives
                    unDomains
                    pfamDomainPosHmm
                    unLigandsBindingSite
                    unAnnPropActiveSite
                    phosPtms
                    unGlycosylations
                    unLipidations
                    unModifiedRes
                    unDisulfideBongBridges
                    unSecondaryStructure
                    afPredictedSecondaryStructure
                    afConfidenceValue
                    unCrossLinks
                    inBindingRegion
                    interproDomain
                    summary
                    clinvarVariants {
                      locationG37
                      locationG38
                      ref
                      alt
                      variant
                      consequence
                      clinicalSignificance
                      disease
                      proteinPosition
                      aaChange
                      codon
                      alphamissenseScore
                      alphamissenseClass
                      url
                    }
                  }
                }
              `
            };

        const query_residue = {
              query: `
                query getResidueByPosition {
                  residue(anPosition: "${target.toUpperCase()}") {
                    anPosition
                      unRefProtRe
                    afRes
                    unAnnNatVariants
                    unMoleculeProcessing
                    unLocation
                    unMotives
                    unDomains
                    pfamDomainPosHmm
                    unLigandsBindingSite
                    unAnnPropActiveSite
                    phosPtms
                    unGlycosylations
                    unLipidations
                    unModifiedRes
                    unDisulfideBongBridges
                    unSecondaryStructure
                    afPredictedSecondaryStructure
                    afConfidenceValue
                    unCrossLinks
                    inBindingRegion
                    summary
                    interproDomain
                    clinvarVariants {
                      locationG37
                      locationG38
                      ref
                      alt
                      variant
                      consequence
                      clinicalSignificance
                      disease
                      proteinPosition
                      aaChange
                      codon
                      alphamissenseScore
                      alphamissenseClass
                      url
                    }
                  }
                }
              `
            };

        const query_gene_residue = {
              query: `
                query getResidueByGeneAndPosition {
                  residueByGeneSymbolAndPosition(genePosition: "${target.toUpperCase()}") {
                   anPosition
                    unRefProtRe
                    afRes
                    unAnnNatVariants
                    unMoleculeProcessing
                    unLocation
                    unMotives
                    unDomains
                    pfamDomainPosHmm
                    unLigandsBindingSite
                    unAnnPropActiveSite
                    phosPtms
                    unGlycosylations
                    unLipidations
                    unModifiedRes
                    unDisulfideBongBridges
                    unSecondaryStructure
                    afPredictedSecondaryStructure
                    afConfidenceValue
                    unCrossLinks
                    inBindingRegion
                    interproDomain
                    summary
                    clinvarVariants {
                      locationG37
                      locationG38
                      ref
                      alt
                      variant
                      consequence
                      clinicalSignificance
                      disease
                      proteinPosition
                      aaChange
                      codon
                      alphamissenseScore
                      alphamissenseClass
                      url
                    }
                  }
                }
              `
            };

        let variantData = null;
        let type = "";
        const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';

        if (isValidUniProtAccession(target) && !isValidResidue(target)){
           variantData = await axios.post(apiUrl, query_protein);
           type = "protein";
        } else if (isValidResidue(target)){
          variantData = await axios.post(apiUrl, query_residue);
          type = "residue";
        } else if (isValidGeneSymbol(target)) {
          variantData = await axios.post(apiUrl, query);
          type = "gene";
        }else if (isValidGeneResidue(target)) {
          variantData = await axios.post(apiUrl, query_gene_residue);
          type = "gene_residue";
        }

        const checkDataAndNavigate = () => {
          // Check for no errors and data is present
          if (!variantData.data.errors && variantData.data.data) {
            switch (type) {
              case "gene":
                 return variantData.data.data.residuesByGeneSymbol;
                break;
              case "residue":
                 return [variantData.data.data.residue];
                break;
              case "protein":
                 return variantData.data.data.residues;
                break;
              case "gene_residue":
                 return [variantData.data.data.residueByGeneSymbolAndPosition];
                break;
              default:
                return [];
            }
          }
        }

       return checkDataAndNavigate(); // Return the data retrieved

     } catch (error) {
          console.error(error);
     }
}

// Function to send form data to the API
export async function sendExploreData(target, type) {
  try {
    const queries = {
      gene: {
        query: `
          query getResiduesByGene {
            residuesByGeneSymbol(geneSymbol: "${target.toUpperCase()}") {
              anPosition
              unRefProtRe
              afRes
              unAnnNatVariants
              unMoleculeProcessing
              unLocation
              unMotives
              unDomains
              pfamDomainPosHmm
              unLigandsBindingSite
              unAnnPropActiveSite
              phosPtms
              unGlycosylations
              unLipidations
              unModifiedRes
              unDisulfideBongBridges
              unSecondaryStructure
              afPredictedSecondaryStructure
              afConfidenceValue
              unCrossLinks
              inBindingRegion
              interproDomain
               unMotivesEvidence
                    unDomainsEvidence
                    unLocationEvidence
                    unMoleculeProcessingEvidence
                    unAnnNatVariantsEvidence
                    unCrossLinksEvidence
                    unLipidationsEvidence
                    unGlycosylationsEvidence
                    unDisulfideBongBridgesEvidence
                    unSecondaryStructureEvidence
                    unAnnPropActiveSiteEvidence
                    unLigandsBindingSiteEvidence
                    unModifiedResEvidence
                    summary
                    aamissense {
                        amClass
                        amMean
                        amMax
                        amMin
                        amPathogenicFrac
                    }
            }
          }
        `,
      },
      protein: {
        query: `
          query getResiduesByProtein {
            residues(proteinAn: "${target.toUpperCase()}") {
              anPosition
              unRefProtRe
              afRes
              unAnnNatVariants
              unMoleculeProcessing
              unLocation
              unMotives
              unDomains
              pfamDomainPosHmm
              unLigandsBindingSite
              unAnnPropActiveSite
              phosPtms
              unGlycosylations
              unLipidations
              unModifiedRes
              unDisulfideBongBridges
              unSecondaryStructure
              afPredictedSecondaryStructure
              afConfidenceValue
              unCrossLinks
              inBindingRegion
              interproDomain
               unMotivesEvidence
                    unDomainsEvidence
                    unLocationEvidence
                    unMoleculeProcessingEvidence
                    unAnnNatVariantsEvidence
                    unCrossLinksEvidence
                    unLipidationsEvidence
                    unGlycosylationsEvidence
                    unDisulfideBongBridgesEvidence
                    unSecondaryStructureEvidence
                    unAnnPropActiveSiteEvidence
                    unLigandsBindingSiteEvidence
                    unModifiedResEvidence
                    summary
                    aamissense {
                        amClass
                        amMean
                        amMax
                        amMin
                        amPathogenicFrac
                    }
            }
          }
        `,
      },
      residue: {
        query: `
          query getResidueByPosition {
            residue(anPosition: "${target.toUpperCase()}") {
              anPosition
              unRefProtRe
              afRes
              unAnnNatVariants
              unMoleculeProcessing
              unLocation
              unMotives
              unDomains
              pfamDomainPosHmm
              unLigandsBindingSite
              unAnnPropActiveSite
              phosPtms
              unGlycosylations
              unLipidations
              unModifiedRes
              unDisulfideBongBridges
              unSecondaryStructure
              afPredictedSecondaryStructure
              afConfidenceValue
              unCrossLinks
              inBindingRegion
              interproDomain
               unMotivesEvidence
                    unDomainsEvidence
                    unLocationEvidence
                    unMoleculeProcessingEvidence
                    unAnnNatVariantsEvidence
                    unCrossLinksEvidence
                    unLipidationsEvidence
                    unGlycosylationsEvidence
                    unDisulfideBongBridgesEvidence
                    unSecondaryStructureEvidence
                    unAnnPropActiveSiteEvidence
                    unLigandsBindingSiteEvidence
                    unModifiedResEvidence
                    summary
                    aamissense {
                        amClass
                        amMean
                        amMax
                        amMin
                        amPathogenicFrac
                    }
            }
          }
        `,
      },
      gene_residue: {
        query: `
          query getResidueByGeneAndPosition {
            residueByGeneSymbolAndPosition(genePosition: "${target.toUpperCase()}") {
              anPosition
              unRefProtRe
              afRes
              unAnnNatVariants
              unMoleculeProcessing
              unLocation
              unMotives
              unDomains
              pfamDomainPosHmm
              unLigandsBindingSite
              unAnnPropActiveSite
              phosPtms
              unGlycosylations
              unLipidations
              unModifiedRes
              unDisulfideBongBridges
              unSecondaryStructure
              afPredictedSecondaryStructure
              afConfidenceValue
              unCrossLinks
              inBindingRegion
              interproDomain
               unMotivesEvidence
                    unDomainsEvidence
                    unLocationEvidence
                    unMoleculeProcessingEvidence
                    unAnnNatVariantsEvidence
                    unCrossLinksEvidence
                    unLipidationsEvidence
                    unGlycosylationsEvidence
                    unDisulfideBongBridgesEvidence
                    unSecondaryStructureEvidence
                    unAnnPropActiveSiteEvidence
                    unLigandsBindingSiteEvidence
                    unModifiedResEvidence
                    summary
                    aamissense {
                        amClass
                        amMean
                        amMax
                        amMin
                        amPathogenicFrac
                    }
            }
          }
        `,
      },
    };

    // Select the appropriate query based on the type
    const query = queries[type];
    if (!query) {
      Swal.fire({
        icon: "info",
        text: "Invalid search type! Please check your criteria and try again.",
      });
      return null;
    }

    const apiUrl = "https://api.atlantis.bioinfolab.sns.it/graphql";
    const response = await axios.post(apiUrl, query);

    // Check if the response has data and no errors
    if (response?.data?.errors) {
      console.error("API Errors:", response.data.errors);
      Swal.fire({
        icon: "error",
        text: "An error occurred while fetching data from the server.",
      });
      return null;
    }

    const data = response.data.data;

    if (!data) {
      console.error("No data received from API");
      return null;
    }

    // Handle data based on the type and return the appropriate data
    switch (type) {
      case "gene":
        return data.residuesByGeneSymbol?.length > 0 ? { data } : null;
      case "protein":
        return data.residues?.length > 0 ? { data } : null;
      case "residue":
        return data.residue ? { data } : null;
      case "gene_residue":
        return data.residueByGeneSymbolAndPosition ? { data } : null;
      default:
        return null;
    }
  } catch (error) {
    console.error("Error in sendExploreData:", error.message);
    Swal.fire({
      icon: "error",
      text: "An error occurred: " + error.message,
    });
    return null;
  }
}

// Create colors
export function createDomainsColors(dataResidue) {
    const domains = dataResidue
        .filter(residue => residue.unDomains.trim() !== "no_domain")
        .map(residue => residue.unDomains);

    // Remove duplicates from the domains array
    const uniqueDomains = [...new Set(domains)];

    const colors = {};

    const color_map = [
            "ff5733", // Bright Red
            "33ff57", // Bright Green
            "3357ff", // Bright Blue
            "ff33a1", // Bright Pink
            "a1ff33", // Lime Green
            "ffac33", // Bright Orange
            "33ffd7", // Cyan
            "f3ff33", // Yellow
            "ff33c4", // Magenta
            "5733ff", // Purple
            "ff3371", // Light Red
            "33ff8a", // Teal
            "ffb833", // Gold
            "338cff", // Sky Blue
            "f033ff", // Violet
            "ff9933", // Amber
            "33ff6e", // Sea Green
            "ff5f33", // Coral
            "33d3ff", // Azure
            "ff3333", // Crimson
            "ff9933", // Peach
            "ff5733", // Tomato
            "33ff57", // Lime
            "6b33ff", // Indigo
            "ff33f5"  // Hot Pink
       ];

    uniqueDomains.forEach((domain, index) => {
        // Assign a color from color_map based on the index
        const colorIndex = index % color_map.length; // Loop back if out of bounds
        colors[domain] = `${color_map[colorIndex]}`; // Convert to hex
    });
    return colors;
}

export async function getInterProDomains(uniAcc) {

    let domainList = [];

    try {
        const query = {
            query: `
                query getInterproDomains($uniAcc: String!) {
                  getInterproDomains(uniprotAccession: $uniAcc) {
                    interproEntry
                    domainName
                    start
                    end
                    color
                  }
                }
            `,
            variables: {
                uniAcc: uniAcc,
            },
        };

        const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';
        const domains = await axios.post(apiUrl, query);

        if (domains.data) {
            if (domains.data.data.getInterproDomains) {
                domainList = domains.data.data.getInterproDomains;
            }
        }
    } catch (error) {
        console.error(error);
    }

    // domainList will now always be defined
    return domainList;
}


export async function structureMap(contacts, pdb, uniAcc) {

  if (!contacts?.length) return; // Exit early if contacts is empty or falsy

  try {
    const results = await getPDB2Uniprot(pdb, uniAcc, contacts);

    if (!results?.length) return; // Exit early if results are empty

    const mappedPositions = [];
    const chains = [];

    results.forEach(({ pdbresPos }) => {
      const chain = pdbresPos.split("|")[0];
      const position = parseInt(pdbresPos.match(/\d+/)?.[0]); // Fixed 'posStr' to 'pdbresPos'

      if (position && chain) {
        mappedPositions.push(position);
        chains.push(chain);
      }
    });
    return { mappedPositions, chains }; // Returning the mapped data


  } catch (error) {
    console.error("Error in structureMap:", error);
  }
}

export async function structureMapInteractions(contacts, pdb, uniAcc) {

  if (!contacts?.length) return; // Exit early if contacts is empty or falsy

  try {
    const results = await getPDB2Uniprot(pdb, uniAcc, contacts);

    if (!results?.length) return; // Exit early if results are empty

    const mappedPositions = [];
    const chains = [];
    const residues = [];

    results.forEach(({ pdbresPos }) => {
      const chain = pdbresPos.split("|")[0];
      const position = parseInt(pdbresPos.match(/\d+/)?.[0]); // Fixed 'posStr' to 'pdbresPos'
      const residue = pdbresPos.match(/^[^|]+\|([A-Z]{3})\d+$/)[1];

      if (position && chain && residue) {
        mappedPositions.push(position);
        chains.push(chain);
        residues.push(residue)
      }
    });
    return { mappedPositions, chains,  residues }; // Returning the mapped data


  } catch (error) {
    console.error("Error in structureMap:", error);
  }
}

// Get overview data for tab
export async function getOverview(target) {
    try {
        const query = {
            query: `
                query getOverview($target: String!) {
                  getOverview(target: $target) {
                        family
                        status
                        name
                        seqLength
                        subcellularLocation
                        subcellularLocationEvidence
                        crossReferences
                        countByFeatureType
                  }
                }
            `,
            variables: {
                target: target,
            },
        };

        const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';
        const dta = await axios.post(apiUrl, query);

        if (dta.data) {
            if (dta.data.data.getOverview) {
                return dta.data.data.getOverview
            }
        }
    } catch (error) {
        console.error(error);
    }

    return null;
}

// Get overview data for tab
export async function getCif(target) {
    try {
        const query = {
            query: `
                query getCif($target: String!) {
                  getCif(target: $target) {
                       structure
                  }
                }
            `,
            variables: { target },
        };

        const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';
        const res = await axios.post(apiUrl, query);

        if (res.data?.data?.getCif?.structure) {
            return res.data.data.getCif.structure;
        }
    } catch (error) {
        console.error('Error fetching CIF:', error);
    }

    return null;
}

// Function to get identifiers from API
export async function getStructureContact(target, kind) {

  try {
    const query = {
      query: `
        query getIdentifiers {
          getIdentifiers(target: "${target.toUpperCase()}", kind: "${kind}") {
            structure
          }
        }
      `
    };

    const apiUrl = 'https://api.atlantis.bioinfolab.sns.it/graphql';
    const contactData = await axios.post(apiUrl, query);

    let responseData = null;
    if (!contactData.data.errors && contactData.data.data) {
      responseData = contactData.data.data;
    }

    const list = responseData?.getIdentifiers?.map(r => r.structure) ?? [];

    return list;

  } catch (error) {
    console.error(error);
    return { list: [] };
  }
}

const ATLANTIS_API = 'https://api.atlantis.bioinfolab.sns.it/graphql';
const ATLANTIS_EXPORT = 'https://api.atlantis.bioinfolab.sns.it/export/contacts';
export const CONTACT_DISPLAY_LIMIT = 10000;

export async function getContactsByStructure(target, identifier) {
  try {
    const query = {
      query: `query {
        contactsByStructure(target: "${target.toUpperCase()}", identifier: "${identifier}", pagination: {offset: 0, limit: ${CONTACT_DISPLAY_LIMIT + 1}}) {
          total
            items {
              anPosition
              summary
              contactPosition
              details
              distance
              identifier
              proteinUid
            }
        }
      }`,
    };
    const resp = await axios.post(ATLANTIS_API, query);
    console.log(resp)
    if (resp.data.errors || !resp.data.data) return { contacts: [], tooMany: false, total: 0 };
    const data = resp.data.data.contactsByStructure || { total: 0, items: [] };
    const total = data.total || 0;
    if (total > CONTACT_DISPLAY_LIMIT) return { contacts: [], tooMany: true, total };
    return { contacts: data.items || [], tooMany: false, total };
  } catch (error) {
    console.error(error);
    return { contacts: [], tooMany: false };
  }
}

// Search by residue: all contacts of one an_position across every structure.
export async function getContactsByResidue(anPosition) {
  try {
    const query = {
      query: `query {
        contactsByTarget(target: "", anPosition: "${anPosition.toUpperCase()}", pagination: {offset: 0, limit: ${CONTACT_DISPLAY_LIMIT}}) {
          total
          items {
          summary
          anPosition
          proteinUid
          identifier
          contactPosition
          distance
          details
          }
        }
      }`,
    };
    const resp = await axios.post(ATLANTIS_API, query);
    if (resp.data.errors || !resp.data.data) return { contacts: [], tooMany: false, total: 0 };
    const data = resp.data.data.contactsByTarget || { total: 0, items: [] };
    const total = data.total || 0;
    if (total > CONTACT_DISPLAY_LIMIT) return { contacts: [], tooMany: true, total };
    return { contacts: data.items || [], tooMany: false, total };
  } catch (error) {
    console.error(error);
    return { contacts: [], tooMany: false, total: 0 };
  }
}

// Server-streamed CSV URL (the escape hatch for the > limit cases).
export function buildContactsCsvUrl({ target, identifier, anPosition }) {
  const params = new URLSearchParams();
  params.set('target', (target || '').toUpperCase());
  if (identifier) params.set('identifier', identifier);
  if (anPosition) params.set('an_position', anPosition.toUpperCase());
  return `${ATLANTIS_EXPORT}?${params.toString()}`;
}
